
import {
    GET_LOCAL_TRIPS_LIST,
    CLEAR_LOCAL_TRIPS_LIST,
    GET_LOCAL_TRIP_DETAIL,
    CLEAR_LOCAL_TRIP_DETAIL,
    CREATE_LOCAL_TRIP,
    CLEAR_CREATE_LOCAL_TRIP,
    GET_LOCAL_TRIP_REASONS,
    CLEAR_LOCAL_TRIP_REASONS,
    GET_LOCAL_TRIP_DECISIONS,
    CLEAR_LOCAL_TRIP_DECISIONS,
    CANCEL_LOCAL_TRIP,
    CLEAR_CANCEL_LOCAL_TRIP,
    APPROVE_LOCAL_TRIP,
    CLEAR_APPROVE_LOCAL_TRIP,
    GET_ERROR_LOCAL_TRIP,
    CLEAR_ERROR_LOCAL_TRIP, CLEAR_CREATED_LOCAL_TRIP,
} from "../../enums/LocalTrips/LocalTrips.types";

// Список командировок
export const getLocalTripsListAction = (data) => ({
    type: GET_LOCAL_TRIPS_LIST,
    payload: data,
});

export const clearLocalTripsListAction = () => ({
    type: CLEAR_LOCAL_TRIPS_LIST,
});

// Детали командировки
export const getLocalTripDetailAction = (data) => ({
    type: GET_LOCAL_TRIP_DETAIL,
    payload: data,
});

export const clearLocalTripDetailAction = () => ({
    type: CLEAR_LOCAL_TRIP_DETAIL,
});

// Создание командировки
export const createLocalTripAction = (data) => ({
    type: CREATE_LOCAL_TRIP,
    payload: data,
});

export const clearCreateLocalTripAction = () => ({
    type: CLEAR_CREATE_LOCAL_TRIP,
});

// Причины отсутствия
export const getLocalTripReasonsAction = (data) => ({
    type: GET_LOCAL_TRIP_REASONS,
    payload: data,
});

export const clearLocalTripReasonsAction = () => ({
    type: CLEAR_LOCAL_TRIP_REASONS,
});

// Решения руководителя
export const getLocalTripDecisionsAction = (data) => ({
    type: GET_LOCAL_TRIP_DECISIONS,
    payload: data,
});

export const clearLocalTripDecisionsAction = () => ({
    type: CLEAR_LOCAL_TRIP_DECISIONS,
});

// Отмена командировки
export const deleteLocalTripAction = (id) => ({
    type: CANCEL_LOCAL_TRIP,
    payload: id,
});

export const clearCancelLocalTripAction = () => ({
    type: CLEAR_CANCEL_LOCAL_TRIP,
});

// Согласование/отклонение
export const approveLocalTripAction = (data) => ({
    type: APPROVE_LOCAL_TRIP,
    payload: data,
});

export const clearApproveLocalTripAction = () => ({
    type: CLEAR_APPROVE_LOCAL_TRIP,
});

// Ошибки
export const getErrorLocalTripAction = (error) => {
    console.log(error);
  return  {
    type: GET_ERROR_LOCAL_TRIP,
    payload: error,
};

}
export const clearErrorLocalTripAction = () => ({
    type: CLEAR_ERROR_LOCAL_TRIP,
});


export const clearLocalTripErrorAction = () => ({
    type: CLEAR_ERROR_LOCAL_TRIP,
});

export const clearCreatedLocalTripAction = () => ({
    type: CLEAR_CREATED_LOCAL_TRIP,
});

